var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.hideHeader)?_c('a-layout-header',{class:[
    'layout-header',
    _vm.fixedHeader && 'layout-header__fixed',
    _vm.layoutMode === 'side' ? 'layout-header__light' : `layout-header__${_vm.menuTheme}`
  ]},[_c('div',{staticClass:"header-left"},[(_vm.showTrigger)?_c('a-icon',{staticClass:"trigger",attrs:{"type":_vm.triggerIconType},on:{"click":function($event){return _vm.$emit('toggle')}}}):_vm._e(),(_vm.layoutMode === 'top' && !_vm.isMobile)?_c('Logo'):_vm._e(),(_vm.showMenu)?_c('Menu',{attrs:{"mode":"horizontal"}}):_vm._e()],1),_c('div',{staticClass:"header-right"},[_c('Actions')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }